import getBirthdayCalendarCurrentState from '../selectors/getBirthdayCalendarCurrentState';
import logDataOnSaveBirthdayCalendarOption from '../utils/logDataOnSaveBirthdayCalendarOption';
import enableBirthdayCalendar from '../services/enableBirthdayCalendar';
import disableBirthdayCalendar from '../services/disableBirthdayCalendar';
import { birthdayCalendarOptionUpdated } from '../actions/publicActions';
import { updateBirthdayCalendarInitialState } from '../actions/internalActions';
import CalendarActionResponse from 'owa-service/lib/contract/CalendarActionResponse';
import { trace } from 'owa-trace';
import CalendarActionFolderIdResponse from 'owa-service/lib/contract/CalendarActionFolderIdResponse';

/**
 * Called when clicked on save button in calendar settings panel.
 * Invokes EnableBirthdayCalendar or DisableBirthdayCalendar service call
 * Trigger an action so that selected calendars changes are reflected in current calendar session of the user
 */
export default async function saveBirthdayCalendarOption() {
    let birthdayCalendarEnabled = getBirthdayCalendarCurrentState();

    let response: CalendarActionResponse = null;
    // save the new calendar setting at server
    if (!!birthdayCalendarEnabled) {
        response = await enableBirthdayCalendar();
    } else {
        response = await disableBirthdayCalendar();
    }

    if (response && response.WasSuccessful) {
        if (birthdayCalendarEnabled) {
            let folderIdResponse: CalendarActionFolderIdResponse = response;
            if (!folderIdResponse || !folderIdResponse.NewFolderId) {
                trace.warn(
                    'saveBirthdayCalendarOption failed : Invalid response for EnableBirthdayCalendar'
                );
                return;
            }
        }
        updateBirthdayCalendarInitialState(birthdayCalendarEnabled);
        logDataOnSaveBirthdayCalendarOption();

        // trigger an action for existing calendar module to update the selected calendars
        birthdayCalendarOptionUpdated(birthdayCalendarEnabled, response);
    } else {
        let errorCode = response ? response.ErrorCode : 'Unknown';
        trace.warn('saveBirthdayCalendarOption failed with ErrorCode: ' + errorCode);
    }
}
